<template>
  <div class="middle">
    <h1>{{ name }}</h1>
    <h2>COMING SOON</h2>
  </div>
</template>

<script>
export default {
  name: 'ComingSoon',
  props: {
    name: {
      type: String,
    },
  },
};
</script>

<style></style>
